<input *ngIf="columnType==ColType.string || columnType==ColType.date || columnType==ColType.price ||
   columnType==ColType.email || columnType==ColType.stringAndID"
  type="text" class="form-control form-control-sm" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false"
  placement="bottom" triggers="click:blur"
  [hidden]="hasFilterValues" [id]="'columnfilter-'+name" [value]="filterValue" [ngbTooltip]="tooltip"
  (focus)="onFocus()" (keyup)="inputChange($event)" (keyup.enter)="inputSearch($event)">
<input *ngIf="columnType==ColType.number && !hasFilterValues"
  type="text" float-only-input class="form-control form-control-sm" maxlength="7" autocomplete="off" autocorrect="off"
  autocapitalize="none" spellcheck="false" placement="bottom-left" triggers="click:blur"
  [id]="'columnfilter-'+name" [value]="filterValue" [ngbTooltip]="tooltip"
  (focus)="onFocus()" (keyup)="numberChange($event)" (keyup.enter)="numberSearch($event)">
<select [hidden]="!hasFilterValues" class="form-control form-control-sm form-select"
  [id]="'columnfilter-'+name" (change)="selectChange($event)">
  <option value="" [selected]="filterValue==''"></option>
  <option *ngFor="let v of filterValues" value="{{v.key}}" [selected]="filterValue==v.key">{{v.value}}</option>
</select>
